import http from "../http-common";

class FirstPageService {
  createFirstPage(data) {
    return http.post(`/api/first_page`, data);
  }
  getFirstPages() {
    return http.get(`/api/first_page`);
  }
  getFirstPage(id) {
    return http.get(`/api/first_page/`+id);
  }
  updateFirstPage(id, data) {
    return http.put(`/api/first_page/${id}`, data);
  }
}

export default new FirstPageService();